<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH CẤU HÌNH</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_addCauHinh()"
              icon="el-icon-circle-plus-outline"
              >thêm mới cấu hình</el-button
            >
          </div>
        </div>

        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Tên">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ten']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Hiển thị">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['cong_khai']
                          "
                          placeholder="Chọn"
                          clearable
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-button
              type="danger"
              plain
              icon="el-icon-delete"
              :disabled="multipleSelection.length == 0"
              class="mb-2"
              @click="dialogThongBao = true"
              style="text-transform: none"
              >Xóa nhiều cấu hình</el-button
            >
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column type="selection" width="55" align="center">
              </el-table-column>
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ten"
                label="Tên"
                min-width="90"
              ></el-table-column>
              <el-table-column prop="gia_tri" label="Giá trị" min-width="250">
              </el-table-column>
              <el-table-column
                label="Thời điểm cập nhật"
                align="center"
                prop="thoi_diem_cap_nhat"
                width="170"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      fn_date(scope.row.thoi_diem_cap_nhat),
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Công khai" width="100" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.cong_khai"
                    @change="fn_hienThiCauHinh(scope.row, scope.row.cong_khai)"
                  ></el-checkbox>
                </template>
              </el-table-column>

              <el-table-column label="Thao tác" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
          <el-dialog
            title="thông báo"
            :visible.sync="dialogThongBao"
            width="30%"
            center
          >
            <div style="word-break: break-word; text-align: center">
              Bạn có chắc chắn xóa nhiều cấu hình?
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogThongBao = false">Hủy</el-button>
              <el-button type="primary" @click="fn_removeCauHinh()"
                >Đồng ý</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormCauHinh";
import mushroom from "viettoc-api";
import moment from "moment";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      dialogThongBao: false,
      multipleSelection: [],
      options: [
        {
          value: "false",
          label: "Ẩn cấu hình",
        },
        {
          value: "true",
          label: "Công khai",
        },
      ],

      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: "ten,gia_tri,cong_khai,thoi_diem_cap_nhat",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      console.log("this.mData.tableRules", this.mData.tableRules);
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachCauHinh",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }

      try {
        const response = await mushroom.ldp_cau_hinh.listAsync(dataFilter);

        this.loading = false;
        this.mData.tableRules.data = response.result;
        this.mData.tableRules.total = response.meta.total;
        this.mData.tableRules.page =
          response.meta.offset / response.meta.limit + 1;
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },

    fn_date(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "DanhSachCauHinh",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ten"]) {
        this.mData.tableRules.dataSearch.value["ten"] =
          this.mData.tableRules.dataSearch.value["ten"].trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
          console.log(this.mData.tableRules.dataSearch.value["cong_khai"]);
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietCauHinh",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatCauHinh",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    async fn_delete(id) {
      try {
        const response = await mushroom.ldp_cau_hinh.deleteAsync({ id: id });
        if (response.result) {
          window.toastr.success("Xóa cấu hình giới thiệu thành công");
        }
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        } else {
          window.toastr.error("Đã có lỗi xảy ra. Hãy thử lại");
        }
      }
      this.fn_initTable();
    },

    // cập nhật trạng thái hiển thị/ẩn trạng thái
    async fn_hienThiCauHinh(row) {
      const ldp_cau_hinh_object = {
        id: row.id,
        cong_khai: row.cong_khai,
      };
      try {
        const response = await mushroom.ldp_cau_hinh.partialUpdateAsync(
          ldp_cau_hinh_object
        );
        if (response.result == ldp_cau_hinh_object.id) {
          this.fn_initTable();
          window.toastr.success("Cập nhật trạng thái cấu hình thành công ");
        } else console.log("Dữ liệu không thay đổi");
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },

    // Xóa nhiều Cấu hình
    handleSelectionChange(val) {
      this.multipleSelection = [];
      let arrayId = val;
      arrayId.forEach((item) => {
        this.multipleSelection.push(item.id);
      });
    },
    //
    async fn_removeCauHinh() {
      try {
        await mushroom.ldp_cau_hinh.batchDeleteAsync({
          ids: this.multipleSelection,
        });
        this.dialogThongBao = false;
        this.fn_initTable();
        window.toastr.success("Xóa nhiều cấu hình thành công");
      } catch (e) {
        console.error("Có lỗi: %o", e);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_addCauHinh() {
      this.$router.push({
        name: "ThemCauHinh",
      });
    },
  },

  // computed: {
  //   timeCapNhat() {
  //     return this.timeCapNhats.forEach((item) => {
  //       item.thoi_diem_cap_nhat = MethodService.formatDate(
  //         item.thoi_diem_cap_nhat,
  //         "date"
  //       );
  //       return item;
  //     });
  //   },
  // },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable();
  },
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}

.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  text-align: center;
  border-radius: 5px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
